import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-115" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-116" data-mp="1dx9shrk4eu7v">
        <SectionHeading id="modules-title" data-id="element-117" data-mp="1dudts10g81id">The {totalVolumes} <span className="text-teal-700" data-id="element-118" data-mp="2bj7dpwpvxdni">Complete Volumes</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-119" data-mp="26kmdvyejovzl">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-120" data-mp="21o5nexjvi5jc" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-121" data-mp="1nt0fuj8ld14g">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700" data-id="element-122" data-mp="18xb218dk7uat">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-123" data-mp="1dv4ay968z2es" />
                  </span>
                  <p className="text-sm font-semibold text-amber-700" data-id="element-124" data-mp="104h7y4tgeqcw">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-base font-semibold leading-snug text-slate-900" data-id="element-125" data-mp="14w92eqfqdg8b">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600" data-id="element-126" data-mp="q84k3nklb6q2">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}